import React from 'react';
import { Switch as MuiSwitch } from '@material-ui/core';
import { noop } from 'lodash';
import useStyles from './Switch.styles';

export interface SwitchProps {
  onChange?: (val: boolean) => void;
  checked?: boolean;
  dataQaId?: string;
  disabled?: boolean;
  ariaLabel?: string;
}

const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange = noop,
  dataQaId,
  disabled,
  ariaLabel = 'switch',
}: SwitchProps) => {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    disabled || onChange(event.target.checked);
  };

  return (
    <MuiSwitch
      onChange={handleChange}
      checked={checked}
      data-qa-id={dataQaId}
      disabled={disabled}
      disableRipple
      color="primary"
      inputProps={{ 'aria-label': ariaLabel }}
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
        disabled: classes.disabled,
      }}
      focusVisibleClassName={classes.focusVisible}
    />
  );
};

export default Switch;
